import { queryServices } from '@wix/ambassador-bookings-services-v2-service/http';
import { uoUWidgetLoadOnLiveSiteSrc187Evid8 } from '@wix/bi-logger-bookings-data/v2';
import { withCancelToken } from '@wix/form-http-essentials';
import { EXPERIMENTS } from '../../constants';
import { WIX_SERVICES_APP_ID } from '../../fields/service-dropdown/service-dropdown-settings/service-settings/constants';
import { isExperimentEnabled } from '../is-experiment-enabled';
import { getServiceOptionIds, serviceSorter } from './service-utils';
const getQueryRequest = (serviceIds)=>{
    return {
        filter: {
            ...serviceIds ? {
                id: {
                    $in: serviceIds
                }
            } : {},
            appId: {
                $eq: WIX_SERVICES_APP_ID
            }
        }
    };
};
export const fetchServices = ({ httpClient: _httpClient, errorHandler })=>{
    return async ({ serviceIds })=>{
        try {
            const response = await errorHandler.withErrorHandler(()=>_httpClient.request(queryServices({
                    query: getQueryRequest(serviceIds)
                })), {
                errorCodesMap: {}
            });
            return response.data.services?.sort(serviceSorter);
        } catch (e) {
            const resolvedError = errorHandler.getResolvedError(e);
            console.error(resolvedError);
            return undefined;
        }
    };
};
export const loadInitialServicesDropdownData = async ({ httpClient, errorHandler, form, isEditor, experiments, bi: biLogger, signal })=>{
    if (isEditor) {
        return {
            services: []
        };
    }
    const useFieldsV2 = isExperimentEnabled(experiments, EXPERIMENTS.USE_FIELDS_V2) || isExperimentEnabled(experiments, EXPERIMENTS.USE_FIELDS_V2_STANDALONE);
    const serviceIds = getServiceOptionIds(form, useFieldsV2);
    try {
        const services = await errorHandler.withErrorHandler(()=>httpClient.request(withCancelToken(queryServices({
                query: getQueryRequest(serviceIds)
            }), signal, httpClient)), {
            errorCodesMap: {}
        });
        const activeServiceIds = services?.data?.services?.map((service)=>service.id);
        if (activeServiceIds?.length) {
            biLogger?.report(uoUWidgetLoadOnLiveSiteSrc187Evid8({
                widgetName: 'service-dropdown',
                servicesIds: activeServiceIds.join(','),
                environment: JSON.stringify({
                    isEditor
                })
            }));
        }
        return {
            services: services.data.services?.sort(serviceSorter)
        };
    } catch (e) {
        const resolvedError = errorHandler.getResolvedError(e);
        console.error(resolvedError);
        throw resolvedError;
    }
};

//# sourceMappingURL=fetch-services.js.map